import React from 'react';

import "./theme/_main.scss";

import TextLineEdit from '@plone/volto/components/manage/TextLineEdit/TextLineEdit';
import Body from '@plone/volto/components/manage/Blocks/Video/Body';
import { NarrowContainer } from '../../customizations/components/theme/Container/Container';
import { Container } from '../../customizations/components/theme/Container/Container';
import { UniversalLink } from '@plone/volto/components';

const View = (props) => {
    const { data, isEditMode, filteredToolbarProps } = props;

    return (
        <div className="custom-block button-block">
            {isEditMode ? (
                <>
                    <TextLineEdit
                        {...filteredToolbarProps}
                        renderTag="h2"
                        renderClassName={``}
                        fieldDataName="title"
                        properties={{ title: data.title }}
                    />
                </>
            ) : (
                <h2>
                    <span className='animated'>
                        {data?.title}

                    </span>
                </h2>
            )}
            <NarrowContainer>
                {isEditMode ? (
                    <TextLineEdit
                        {...filteredToolbarProps}
                        renderTag="p"
                        renderClassName=""
                        fieldDataName="text"
                        properties={{ text: data.text }}
                        placeholder="Text eingeben"
                    />
                ) : (
                    <p>
                        <span className='animated'>
                            {data.text}
                        </span>
                    </p>
                )}
            </NarrowContainer>
            <UniversalLink href={isEditMode ? "" : data.button_link}>
                {data.button_text}
            </UniversalLink >
        </div >
    );
};

export default View;
